import { przezmorzeApi } from "../../../api/api";
import type {
  CreateProductOptionDictionaryEntryRequest,
  ProductOptionDictionaryEntry,
  ProductOptionDictionaryEntryListResponse,
} from "@przezmorze/api-types";

export type ProductOption = ProductOptionDictionaryEntry;
export type CreateOrUpdateProductOptionRequestBody = CreateProductOptionDictionaryEntryRequest;

export async function listProductOptions(abortSignal?: AbortSignal) {
  const response = await przezmorzeApi.get<ProductOptionDictionaryEntryListResponse>("/product-options", {
    signal: abortSignal,
  });
  return response.data.items;
}

export async function addProductOption(
  body: CreateOrUpdateProductOptionRequestBody,
  abortSignal?: AbortSignal,
): Promise<ProductOption> {
  const response = await przezmorzeApi.post<ProductOption>("/product-options", body, {
    signal: abortSignal,
  });
  return response.data;
}

export async function updateProductOptionNameAndRoomConfig(
  optionId: string,
  body: CreateOrUpdateProductOptionRequestBody,
  abortSignal?: AbortSignal,
) {
  const response = await przezmorzeApi.patch<ProductOption>(`/product-options/${optionId}`, body, {
    signal: abortSignal,
  });
  return response.data;
}

export async function deleteProductOption(id: string, force: boolean, abortSignal?: AbortSignal): Promise<void> {
  await przezmorzeApi.delete<void>(`/product-options/${id}`, {
    params: { force },
    signal: abortSignal,
  });
}
